import Vue from 'vue'

/**
 * @param Component vue组件
 * @param props 组件实例中的prop
 */
export function createFilePreview(Component, props) {
	const comp = new (Vue.extend(Component))({ propsData: props }).$mount()
	document.body.appendChild(comp.$el)

	window.$destroyFilePreview = comp.remove = () => {
		if(comp) {
			try {
				document.body.removeChild(comp.$el)
				comp.$destroy()
			} catch (e) {
				document.querySelectorAll('.filePreviewElement').forEach(e => e.remove())
			}
		}
	}

	return comp
}
